module.exports = __webpack_public_path__ + "img/43_61.f0f3ca5f.png";